import script from "./NewsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsCard.vue?vue&type=script&setup=true&lang=ts"

import "./NewsCard.vue?vue&type=style&index=0&id=1c6579e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c6579e0"]])

export default __exports__